import colors from '@lmc/common/constants'
import React from 'react'

export const FlagTransparentIcon = (
  <svg
    aria-hidden="true"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5001 4H15.1667L13.8334 8L15.1667 12H6.16675"
      stroke={colors.black}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.16675 1.33331H10.5001V9.33331H2.16675"
      stroke={colors.black}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.16675 12V11"
      stroke={colors.black}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.16675 0.666656V15.3333"
      stroke={colors.black}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FlagColouredIcon = (
  <svg
    aria-hidden="true"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5001 9.66667H2.50008C2.31584 9.66667 2.16675 9.51742 2.16675 9.33333C2.16675 9.14925 2.31584 9 2.50008 9H10.5001C10.6843 9 10.8334 9.14925 10.8334 9.33333C10.8334 9.51742 10.6843 9.66667 10.5001 9.66667Z"
      fill="#BA66DD"
    />
    <path
      d="M15.1667 12.3334H6.50008C6.31584 12.3334 6.16675 12.1841 6.16675 12V4.00002C6.16675 3.81594 6.31584 3.66669 6.50008 3.66669H15.1667C15.2738 3.66669 15.3744 3.71812 15.4373 3.8052C15.4998 3.89211 15.517 4.00376 15.4828 4.10549L14.1847 8.00002L15.4828 11.8946C15.517 11.9963 15.4998 12.1079 15.4373 12.1948C15.3744 12.2819 15.2738 12.3334 15.1667 12.3334Z"
      fill="#D85B55"
    />
    <path
      d="M6.50008 12.3334C6.44604 12.3334 6.39201 12.3203 6.34285 12.294C6.23445 12.2359 6.16675 12.1229 6.16675 12V4.00002C6.16675 3.81594 6.31584 3.66669 6.50008 3.66669H10.5001C10.6843 3.66669 10.8334 3.81594 10.8334 4.00002V9.33335C10.8334 9.44484 10.7778 9.54885 10.685 9.6107L6.68498 12.2774C6.62931 12.3145 6.56486 12.3334 6.50008 12.3334Z"
      fill="#C64B4B"
    />
    <path
      d="M10.5001 9.66667H2.50008C2.31584 9.66667 2.16675 9.51742 2.16675 9.33333V1.33333C2.16675 1.14925 2.31584 1 2.50008 1H10.5001C10.6843 1 10.8334 1.14925 10.8334 1.33333V9.33333C10.8334 9.51742 10.6843 9.66667 10.5001 9.66667Z"
      fill="#E86C60"
    />
    <path
      d="M2.50008 15.6667C2.31584 15.6667 2.16675 15.5174 2.16675 15.3333V0.666677C2.16675 0.482594 2.31584 0.333344 2.50008 0.333344C2.68432 0.333344 2.83341 0.482594 2.83341 0.666677V15.3333C2.83341 15.5174 2.68432 15.6667 2.50008 15.6667Z"
      fill="#333333"
    />
  </svg>
)
